import MoonIcon from './icons/MoonIcon'
import SunIcon from './icons/SunIcon'

export const renderIcon = {
  dark: MoonIcon,
  light: SunIcon,
}
